import { useState, useEffect } from "react";

export const useMousePosition = (isVisible) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (event) => {
      setPosition({ x: event.clientX, y: event.clientY });
    };

    if (isVisible) {
      window.addEventListener("mousemove", handleMouseMove);
    }

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [isVisible]); // Re-run effect only when isVisible changes

  return position;
};
